export default __webpack_public_path__ + "static/media/lucascircle.dd70b552.png";